import lang from 'LANG';

export const headerHandle = ( to ) => {

    let name = to.name || 'homepage';
    let title = lang.t( `meta.${name}` );
    if ( title ) {

        document.title = title;
        
    }

};



// WEBPACK FOOTER //
// ./src/common/js/header.js